<template>
  <div class="bg">
    <div><img :src="data.avatar" /></div>
    <div>{{ data.nick }}</div>
  </div>
</template>

<script>
export default {
  name: 'MineUserIcon',
  props: {
    data: Object
  },
  data() {
    return {
      userInfo: {
        avatar:
          'https://emapp-static.oss-cn-shanghai.aliyuncs.com/youkantou/20200918/98af54996272393d01992f2971b56f6d.png',
        nick: '吴海荣'
      }
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.bg {
  width: 332px;
  height: 124px;
  background-color: #ffffff;
  border: solid 1px #ebebeb;
  display: flex;
  align-items: center;
  border-top: solid 4px #046bcc;
}

img {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}

.bg > div {
  height: 60px;
  font-size: 16px;
  line-height: 60px;
  margin-left: 20px;
}
</style>
